<template lang="html">
  <router-link v-if="to" :to="to" class="link">
    <slot></slot>
  </router-link>
  <a v-else-if="href" :href="href" class="link">
    <slot></slot>
  </a>
  <a v-else @click="click" class="link">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: ['to', 'href'],
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
.link,
a.link:not([href]):not([tabindex]) {
  color: color(primary);
  cursor: pointer;
}
// PROFILES
// .page-vibbrant {
//   .link {
//     color: color(vibbrant);
//   }
// }
// .page-client {
//   .link {
//     color: color(client);
//   }
// }
</style>



// WEBPACK FOOTER //
// src/parts/components/link.vue